import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { useLang } from "../i18n";
import { TESTIMONIALS } from "../data/content";
import { SectionHeading } from "../components/SectionHeading";

export const Testimonials = () => {
  const { lang, L } = useLang();
  const [idx, setIdx] = useState(0);
  const go = (d) => setIdx((p) => (p + d + TESTIMONIALS.length) % TESTIMONIALS.length);
  const t = TESTIMONIALS[idx];

  return (
    <section className="relative py-24 md:py-32">
      <div className="container-pdr">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-end">
          <SectionHeading
            label={lang === "ro" ? "Testimoniale" : "Testimonials"}
            title={lang === "ro" ? "Clienți care ne recomandă." : "Clients who recommend us."}
          />
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1 rounded-full border border-white/10 bg-white/5 px-4 py-2">
              {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-glow-2 text-glow-2" />)}
              <span className="ml-2 font-mono text-sm font-semibold text-white">5.0</span>
            </div>
          </div>
        </div>

        <div className="relative mt-12 overflow-hidden rounded-3xl border border-white/10 bg-surface2/60 p-8 backdrop-blur md:p-14">
          <Quote className="absolute right-8 top-8 h-20 w-20 text-white/5" />
          <div className="pointer-events-none absolute -left-20 top-1/2 h-64 w-64 -translate-y-1/2 rounded-full bg-brand-deep/20 blur-3xl" />
          <AnimatePresence mode="wait">
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.45 }}
              data-testid="testimonial-active"
            >
              <div className="mb-6 flex gap-1">
                {[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 fill-glow-2 text-glow-2" />)}
              </div>
              <p className="max-w-3xl font-display text-2xl font-medium leading-snug text-white md:text-3xl">
                “{L(t)}”
              </p>
              <div className="mt-8 flex items-center gap-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-brand to-brand-deep font-display font-bold text-ink">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="font-semibold text-white">{t.name}</p>
                  <p className="text-sm text-white/50">{L(t.role)}</p>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="mt-10 flex items-center justify-between">
            <div className="flex gap-2">
              {TESTIMONIALS.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIdx(i)}
                  data-testid={`testimonial-dot-${i}`}
                  className={`h-1.5 rounded-full transition-all duration-300 ${i === idx ? "w-8 bg-glow-2" : "w-3 bg-white/20"}`}
                  aria-label={`Testimonial ${i + 1}`}
                />
              ))}
            </div>
            <div className="flex gap-2">
              <button onClick={() => go(-1)} data-testid="testimonial-prev" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white transition-colors hover:border-glow-2/50 hover:text-glow-2">
                <ChevronLeft className="h-5 w-5" />
              </button>
              <button onClick={() => go(1)} data-testid="testimonial-next" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white transition-colors hover:border-glow-2/50 hover:text-glow-2">
                <ChevronRight className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
